import * as React from "react";

const SendEmail = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <path
        d="M30.673 35.974L16 25.701v16.591c0 .943.839 1.708 1.873 1.708h28.255C47.162 44 48 43.235 48 42.292v-16.59L33.328 35.973c-.734.513-1.922.513-2.655 0zM17.873 20C16.837 20 16 20.764 16 21.708v1.684l14.672 10.273c.734.513 1.922.513 2.655 0L48 23.391v-1.684c0-.944-.838-1.708-1.872-1.708H17.872z"
        fill="#7B838C"
      />
    </g>
  </svg>
);

export default SendEmail;

